module.exports = __webpack_public_path__ + "static/media/logo_wardah_grey.4e592629.png";